const Index = () => import('@/views/votingForms/Index.vue')
const Create = () => import('@/views/votingForms/Create.vue')
const Edit = () => import('@/views/votingForms/Edit.vue')
const Results = () => import('@/views/votingForms/Results.vue')

export default [
  {
    path: ':clientId/voting-forms',
    name: 'votingForms.index',
    component: Index,
    meta: { featureKey: 'voting-forms' }
  },
  {
    path: ':clientId/voting-forms/create',
    name: 'votingForms.create',
    component: Create,
    meta: { featureKey: 'voting-forms' }
  },
  {
    path: ':clientId/voting-forms/:uuid/results',
    name: 'votingForms.results',
    component: Results,
    meta: { featureKey: 'voting-forms' }
  },
  {
    path: ':clientId/voting-forms/:uuid',
    name: 'votingForms.edit',
    component: Edit,
    meta: { featureKey: 'voting-forms' }
  }
]
